export function totalTimeString(combinedTime: number) {
  const combinedHoursString = Math.floor(combinedTime / 60).toString();
  const combinedMinutesString = (combinedTime % 60).toString();
  const hourText = "h";
  const minText = "min";
  return `${combinedHoursString}${hourText} ${combinedMinutesString}${minText}`;
}
